import apiConfig from "@/config/apiConfig";
const rootPath = apiConfig.companyApi;

//企业原始信息模块
export const verify = {
    reqGet: rootPath + "/captcha/get", // 修改数据(post)
    reqCheck: rootPath + "/captcha/check", // 新增数据(post)
};
